import { createFileRoute } from '@tanstack/react-router'
import { MarketingHeader, PortalFooter } from '@/components/portal-shell'
import { type TKey, translateApp } from '@/lib/i18n'
import {
	CHANGELOG_ENTRIES,
	formatChangelogDate
} from './-lib/changelog-content'

export const Route = createFileRoute('/changelog')({
	ssr: true,
	component: ChangelogPage
})

function ChangelogPage() {
	const { appLanguage } = Route.useRouteContext()
	const t = (key: TKey) => translateApp(appLanguage, key)

	return (
		<div className='portal-page min-h-svh'>
			<MarketingHeader appLanguage={appLanguage} />
			<main className='portal-container simple-page py-9 pb-20'>
				<div className='simple-page__intro mb-7 max-w-[42.5rem]'>
					<p className='portal-eyebrow'>
						{t('common:changelog.eyebrow')}
					</p>
					<h1>{t('common:changelog.title')}</h1>
					<p className='portal-lead'>
						{t('common:changelog.description')}
					</p>
				</div>
				<section>
					{CHANGELOG_ENTRIES.map((entry) => (
						<article
							className='changelog-item grid gap-1.5 border-(--portal-border) border-t py-[1.625rem] sm:gap-[1.875rem] md:grid-cols-[7.5rem_1fr]'
							key={entry.version}
						>
							<div>
								<p className='portal-eyebrow'>
									{entry.version}
								</p>
								<span className='portal-meta'>
									{formatChangelogDate(
										entry.publishedAt,
										appLanguage
									)}
								</span>
							</div>
							<div>
								<h2>{t(entry.titleKey)}</h2>
								<ul>
									{entry.itemKeys.map((itemKey) => (
										<li key={itemKey}>{t(itemKey)}</li>
									))}
								</ul>
							</div>
						</article>
					))}
				</section>
			</main>
			<PortalFooter appLanguage={appLanguage} />
		</div>
	)
}
